import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { CoreLibModule } from './core-lib.module';
import { ModalLibModule } from './modal-lib.module';

import { FaqComponent, ContactComponent } from '../pages/';



@NgModule({
    imports: [CommonModule, RouterModule, ReactiveFormsModule, CoreLibModule, ModalLibModule],
    declarations: [
        ContactComponent,
        // SupportComponent,
        FaqComponent
    ],
    exports: [
    ]
})
export class Ng2LibModule { }
